import moment from "moment";

import { Typography, Collapse, Input, Radio } from "antd";
import { RightOutlined } from "@ant-design/icons";

import { states } from "utils/objects";

import FloatLabel from "components/Common/FloatLabel";

import './index.scss';

const { Title } = Typography;
const { Panel } = Collapse;

const PatientInfo = (props: any) => {

  const panelHeader = (
    <>
      <div className="row" style={{ color: 'white' }}>
        <div className="col-lg-5">
          Patient Name:
          <br />
          <div className="bold">
            {props.portalClaimMaster.RmiPatientName}
          </div>
        </div>
        <div className="col-lg-5">
          Patient DOB:
          <br />
          <div className="bold">
            {moment(props.portalClaimMaster.RmiPatientBirthDate).format('MM/DD/YYYY')}
          </div>
        </div>
        <div className="col-lg-4">
          Patient ID:
          <br />
          <div className="bold">
            {props.portalClaimMaster.RmiInsuredId}
          </div>
        </div>
        <div className="col-lg-6">
          Patient Plan:
          <br />
          <div className="bold">
            {props.portalClaimMaster.RmiInsuredPlan}
          </div>
        </div>
        <div className="col-lg-4">
          Claim No:
          <br />
          <div className="bold">
            {props.portalClaimMaster.RmiClaimReferenceNo}
          </div>
        </div>
      </div>
    </>
  );
  
  return (
    <Collapse className="mt-3" expandIconPosition="right" expandIcon={({ isActive }) => <RightOutlined style={{ color: 'white' }} rotate={isActive ? 90 : 0} />}>
      <Panel header={panelHeader} key="1" className="panel-header">
        <div className="row flex-lg-wrap justify-content-start mb-3 ml-0 mt-3">
          <div className="col-lg-8 col-md-8">
            <Title level={5}>
              Patient (boxes 2, 3, 5, 6)
            </Title>
            <table className="test"  style={{ textAlign: "left" }}>
              <tbody>
                <tr>
                  <th>Claim No:</th>
                  <td>{props.portalClaimMaster.RmiClaimReferenceNo}</td>
                </tr>
                <tr>
                  <th>Name:</th>
                  <td>{props.portalClaimMaster.RmiPatientName}</td>
                </tr>
                <tr>
                  <th>Address:</th>
                  <td>{props.portalClaimMaster.RmiPatientAddress}</td>
                </tr>
                <tr>
                  <th>City/State/Zip:</th>
                  <td>
                    {props.portalClaimMaster.RmiPatientCity}, {props.portalClaimMaster.RmiPatientState} {props.portalClaimMaster.RmiPatientZip}
                  </td>
                </tr>
                <tr>
                  <th>Phone:</th>
                  <td>{props.portalClaimMaster.RmiPatientPhone}</td>
                </tr>
                <tr>
                  <th>Birth Date:</th>
                  <td>{moment(props.portalClaimMaster.RmiPatientBirthDate).format('MM/DD/YYYY')}</td>
                </tr>

                <tr>
                  <th>Sex:</th>
                  <td>{props.portalClaimMaster.RmiInsuredSex}</td>
                </tr>
                <tr>
                  <th>Patient <br />Relationship to Insured:</th>
                  <td>{props.portalClaimMaster.RmiPatRel}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="col-lg-8 col-md-8">
            <Title level={5}>
              Insured (boxes 1a, 4, 7)
            </Title>
            <table className="test"  style={{ textAlign: "left" }}>
              <tbody>
                <tr>
                  <th>ID Number:</th>
                  <td>{props.portalClaimMaster.RmiInsuredId}</td>
                </tr>
                <tr>
                  <th>Name:</th>
                  <td>{props.portalClaimMaster.RmiInsuredName}</td>
                </tr>
                <tr>
                  <th>Address:</th>
                  <td>{props.portalClaimMaster.RmiInsuredAddress}</td>
                </tr>
                <tr>
                  <th>City/State/Zip:</th>
                  <td>
                    {props.portalClaimMaster.RmiInsuredCity}, {props.portalClaimMaster.RmiInsuredState} {props.portalClaimMaster.RmiInsuredZip}
                  </td>
                </tr>
                <tr>
                  <th>Phone:</th>
                  <td>{props.portalClaimMaster.RmiInsuredPhone}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="col-lg-8 col-md-8">
            <Title level={5}>
              Insurance Information (boxes 11a-d)
            </Title>
            <table className="test"  style={{ textAlign: "left" }}>
              <tbody>
                <tr>
                  <th>Insured's Policy Group or FECA No:</th>
                  <td>{props.portalClaimMaster.RmiInsuredPolicy}</td>
                </tr>
                <tr>
                  <th>Birth Date:</th>
                  <td>{moment(props.portalClaimMaster.RmiInsuredDob).format('MM/DD/YYYY')}</td>
                </tr>
                <tr>
                  <th>Sex:</th>
                  <td>{props.portalClaimMaster.RmiInsuredSex}</td>
                </tr>
                <tr>
                  <th>Insurance Plan or Program Name:</th>
                  <td>
                    {props.portalClaimMaster.RmiInsuredPlan}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="row flex-lg-wrap justify-content-start mb-3 ml-0 mt-3">
          
          <div className="col-lg-8 col-md-8">
            <Title level={5}>
              Other Insurance (boxes 9a-d)
            </Title>
            <FloatLabel 
              label="Other Insured's Name"
              name="insuredName"
              form={props.form}
              required={props.patientInfo.otherPlan === 'Y'}
            >
            <Input />
            </FloatLabel>
        
            <FloatLabel 
              label="Other Insured's Policy or Group No." 
              name="insuredPolicyGroupNo"
              form={props.form}
              required={props.patientInfo.otherPlan === 'Y'}
            >
            <Input />
            </FloatLabel>

            <FloatLabel 
              label="Insurance Plan or Program Name" 
              name="insurancePlan"
              form={props.form}
              required={props.patientInfo.otherPlan === 'Y'}
            >
            <Input />
            </FloatLabel>

            <FloatLabel label="Is There Another Health Benefit Plan?" value={props.patientInfo.otherPlan}>
              <Radio.Group
                style={{ marginLeft: 225 }}
                value={props.patientInfo.otherPlan}
                onChange={ (e) => {
                  props.setPatientInfo( (prev: any) => ({ ...prev, otherPlan: e.target.value }) ); 
                  if (e.target.value === 'N') props.form.resetFields(['insuredName', 'insuredPolicyGroupNo', 'insurancePlan']);
                }}
              >
                <Radio.Button value='Y'>Yes</Radio.Button>
                <Radio.Button value='N'>No</Radio.Button>
              </Radio.Group>
            </FloatLabel>
          </div>

          <div className="col-lg-16 col-md-16">
            <Title level={5}>
              Patient's Condition Related To (boxes 10a-c)
            </Title>

            <FloatLabel label="Employment (Current or Previous)" value={props.patientInfo.employmentAccident}>
              <Radio.Group
                style={{ marginLeft: 210 }}
                value={props.patientInfo.employmentAccident}
                onChange={ (e) => props.setPatientInfo( (prev: any) => ({ ...prev, employmentAccident: e.target.value }) ) }
              >
                <Radio.Button value='Y'>Yes</Radio.Button>
                <Radio.Button value='N'>No</Radio.Button>
              </Radio.Group>
            </FloatLabel>

            <FloatLabel label="Auto Accident?" value={props.patientInfo.autoAccident}>
              <Radio.Group
                style={{ marginLeft: 210 }}
                value={props.patientInfo.autoAccident}
                onChange={ (e) => props.setPatientInfo( (prev: any) => ({ ...prev, autoAccident: e.target.value }) ) }
              >
                <Radio.Button value='Y'>Yes</Radio.Button>
                <Radio.Button value='N'>No</Radio.Button>
              </Radio.Group>
            </FloatLabel>

            {props.patientInfo.autoAccident === 'Y' && (
               <div className="col-lg-4">
               <FloatLabel 
                 label="Place (State)"
                 form={props.form}
                 name="autoAccidentState"
                 validateTrigger={['onBlur']}
                 required
                 rules={[
                  () => ({
                    async validator(_: any, value: string) {
                      if (!value || states.includes(value.toUpperCase())) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error('Invalid State'));
                    },
                  })
                 ]}
               >
                 <Input
                   style={{ marginLeft: 154, width: '100%' }}
                   value={props.patientInfo.autoAccidentState}
                   onChange={ (e) => props.setPatientInfo( (prev: any) => ({ ...prev, autoAccidentState: e.target.value }) ) }
                   placeholder="STATE"
                 />
               </FloatLabel>
               </div>
            )}

            <FloatLabel label="Other Accident?" value={props.patientInfo.otherAccident}>
              <Radio.Group
                style={{ marginLeft: 210 }}
                value={props.patientInfo.otherAccident}
                onChange={ (e) => props.setPatientInfo( (prev: any) => ({ ...prev, otherAccident: e.target.value }) ) }
              >
                <Radio.Button value='Y'>Yes</Radio.Button>
                <Radio.Button value='N'>No</Radio.Button>
              </Radio.Group>
            </FloatLabel>
          </div>
        </div>
      </Panel>
    </Collapse>
  );
};

export default PatientInfo;